import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDispatcherListResponse } from '../../models/dispatcher/dispatcherList.model';

interface IInitialState {
  dispatcherList: IDispatcherListResponse[];
}
const initialState: IInitialState = {
  dispatcherList: [],
};

const dispatcherSlice = createSlice({
  name: 'dispatcher',
  initialState,
  reducers: {
    setDispatcher(state, action: PayloadAction<IInitialState>) {
      state.dispatcherList = action.payload.dispatcherList;
    },
  },
});

export const dispatcherActions = dispatcherSlice.actions;
export default dispatcherSlice.reducer;
